'use strict';

bbw.service.chat.Message = Class({

    method: undefined,
    args: undefined,
    id: undefined,
    deferred: undefined,
    error: undefined,
    send_attempts_count: undefined,
    send_ts: undefined,

    statics: {
        fromJson: function(json) {
            var data = JSON.parse(json);
            if (!angular.isArray(data) || data.length < 2) {
                throw new Error("Malformed JSON received: " + json);
            }
            return new bbw.service.chat.Message(data[0], data[1], data[2]);
        }
    },

    construct: function(id, method, args) {
        this.id = id;
        this.method = '' + method;
        if (!angular.isObject(args)) {
            args = {};
        }
        this.args = args;
        this.send_attempts_count = 0;
    },

    isPairTo: function(message) {
        return angular.isDefined(this.id) && angular.isDefined(this.method)
            && message.id == this.id && message.method == this.method;
    },

    createPromise: function($q) {
        this.deferred = $q.defer();
        return this.deferred.promise;
    },

    resolvePromise: function(responseMessage) {
        if (this.deferred) {
            this.deferred.resolve(responseMessage, this);
        }
    },

    rejectPromise: function(error) {
        console.error('Message error: ', error);
        if (this.deferred) {
            this.error = error;
            this.deferred.reject(this);
        }
    },

    prepareToSend: function() {
        this.send_attempts_count++;
        this.send_ts = +new Date();
        return this;
    },

    isTimedOut: function(ms) {
        if (!this.send_ts) {
            return false;
        }
        return this.send_ts + ms < +new Date();
    },

    toJson: function() {
        return JSON.stringify(
            [
                this.id || null,
                this.method,
                this.args
            ]
        );
    }

});
